import {
  useHotelsStyles,
  useModuleBEM,
  useTenantImages,
} from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { CarouselImageSlider } from "../ImageSlider";
import defaultStyles from "./LodgingPlaceholder.module.scss";

export type LodgingPlaceholderProps = {
  displayImageAsBackground: boolean;
};

export const LodgingPlaceholder = ({
  displayImageAsBackground,
}: LodgingPlaceholderProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.ImageCarousePlaceholder;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const images = useTenantImages();

  return (
    <CarouselImageSlider
      url={images.roomPlaceholder || ""}
      displayImageAsBackground={displayImageAsBackground}
    />
  );
};
